import { resolveURL } from 'ufo';
import { useHttpClient } from '@wix/cli-http-client-react';
import { devMetadataSchema } from '@wix/cli-astro-definitions';
import { useAsyncCallback } from '@wix/cli-ui-kit';

export function useFetchDevMetadata({ base }: { base?: string }) {
  const http = useHttpClient({ type: 'standalone' });

  return useAsyncCallback(async (_, serverLocalUrl: string) => {
    const url = resolveURL(
      serverLocalUrl,
      base ?? '',
      '_wix/dev-metadata.json'
    );
    try {
      const { data } = await http.get(url.toString());
      return {
        devMetadata: devMetadataSchema.parse(data),
        serverLocalUrl,
      };
    } catch {
      return {
        devMetadata: null,
        serverLocalUrl,
      };
    }
  });
}
